// Code-split chunks (the Daily/Solo/Duel screens, animation features) are
// fetched after the page loads. If a deploy lands in between, the files this
// page was built against are gone and the import fails. Reload once to pick
// up the new version; if it still fails, let the error boundary handle it.
const KEY = 'bf_chunk_reload_at';

export function loadOrReload<T>(load: () => Promise<T>): () => Promise<T> {
  return () => load().then(
    mod => {
      try { sessionStorage.removeItem(KEY); } catch { /* ignore */ }
      return mod;
    },
    err => {
      let reloadedRecently = false;
      try {
        reloadedRecently = Date.now() - Number(sessionStorage.getItem(KEY) || 0) < 60_000;
        if (!reloadedRecently) sessionStorage.setItem(KEY, String(Date.now()));
      } catch { /* no storage: don't risk a reload loop */ reloadedRecently = true; }
      if (reloadedRecently) throw err;
      window.location.reload();
      return new Promise<T>(() => {}); // the page is going away
    },
  );
}
